<div #modalContents [class]="lmodalContentsClassWithWidth" aria-modal="true" role="dialog" aria-labelledby="modalTitle">
  <div #modalHead [class]="lmodalHeaderClass">
    <!-- モーダルヘッダーが入ります -->
    <div class="p-modal-head02">
      <h1 id="modalTitle" class="p-modal-head02__title p-modal-head02__title--blue">
        <span [innerHTML]="'label.extraBaggage' | staticMsg"></span>
        <asw-tooltip
          iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
            'm_static_message-alt.helpIcon2' | staticMsg
          }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
          [tooltipContent]="'tooltip.extraBaggage' | staticMsg"
          [tooltipTop]="-80"
          [displayAreaClass]="'p-modal-head02'"
        >
        </asw-tooltip>
      </h1>
      <button id="btn-baggage-close-id" class="p-modal-head02__close js-modal-close" (click)="cancelEvent()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
    <!-- //モーダルヘッダーが入ります -->
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <!-- モーダルの中身が入ります -->
    <div class="p-form-layout04">
      <ng-container *ngFor="let bound of bounds">
        <div class="p-form-layout04__item">
          <div class="p-form-layout04__item-title p-form-layout04__item-title--l">
            <div class="p-form-layout04__item-title-label p-form-layout04__item-title-label--em">
              <div class="p-form-layout04__item-airport">
                <span class="p-form-layout04__item-airport-departure">
                  <font _mstmutation="1">{{
                    getAirportName(bound?.originLocationCode, bound?.originLocationName)
                  }}</font>
                  <span class="p-form-layout04__item-airport-to"
                    ><span class="u-visually-hidden">to</span><span aria-hidden="true">-</span></span
                  > </span
                ><span class="p-form-layout04__item-airport-arrival">{{
                  getAirportName(bound?.destinationLocationCode, bound?.destinationLocationName)
                }}</span>
              </div>
            </div>
          </div>
          <div class="p-input-block02">
            <ng-container *ngFor="let traveler of travelersByINF">
              <div class="p-input-block02__item" *ngIf="isBaggageExist(bound?.airBoundId, traveler?.id)">
                <div
                  class="p-input-block02__item-title p-input-block02__item-title--m p-input-block02__item-title--has-text"
                >
                  <div class="p-input-block02__item-title-label p-input-block02__item-title-label--em">
                    {{ getPassengerName(traveler) }}
                  </div>
                  <div class="p-input-block02__item-title-lead">
                    {{ getPassengerLabel(traveler?.passengerTypeCode) }}
                  </div>
                </div>
                <div
                  *ngIf="isAccompanyingTraveler"
                  class="p-input-block02__item-title p-input-block02__item-title--m p-input-block02__item-title--has-text"
                >
                  <div class="p-input-block02__item-title-label">
                    {{ getAccompanyingPassenger(traveler) }}
                  </div>
                  <div class="p-input-block02__item-title-lead">{{ getAccompanyingPassengerLabel(traveler) }}</div>
                </div>
                <div class="p-input-block02__row">
                  <div class="p-input-block02__row-body">
                    <div class="p-input-block02__row-body-item">
                      <asw-baggage-cataloge
                        [airBoundId]="bound?.airBoundId"
                        [travelerId]="traveler?.id"
                        (changeBaggage)="baggageSelectionValueChangeProcessing($event)"
                      ></asw-baggage-cataloge>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div id="serviceRecommendationArea"></div>
    </div>
    <!-- //モーダルの中身が入ります -->
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <!-- モーダルフッターが入ります -->
    <div class="p-modal-foot01">
      <asw-button
        id="baggage-application-modal-footer-button1"
        [disabled]="screenInformationChangeFlag !== true"
        type="primary"
        size="s-min-w100"
        [label]="'label.apply.button' | staticMsg"
        (click$)="applyEvent()"
      ></asw-button>
    </div>
    <!-- //モーダルフッターが入ります -->
  </div>
</div>
